<template>
  <footer class="slider-footer">
    <section class="container">
      <el-row type="flex" justify="space-between">
        <el-col class="img-wrap" style="width: 315px">
          <img
            src="https://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/kzp/public/bottom-ll.png"
            alt="logo"
          />
        </el-col>
        <el-col class="slider-wrap" style="width: 885px">
          <ul class="slider-hot-box">
            <li
              v-for="(item, index) in hot_cities"
              :key="item.py"
              class="hot-item"
              :class="{ active: curr_hot === index }"
              @mouseenter="setCurrHot(index)"
            >
              <div class="city-wrap">
                <div class="hot-city">{{ item.name }}</div>
                <div class="hot-city-py">{{ item.py }}</div>
              </div>
              <div class="city-qr-code">
                <el-image class="code-img" :src="item.city_qrcode"> </el-image>
              </div>
            </li>
          </ul>
        </el-col>
      </el-row>
      <div class="more-section" v-show="showMore">
        <el-row :gutter="20">
          <el-col
            :span="2"
            v-for="(item, index) in city_list"
            :key="index"
            class="city-item"
          >
            <el-popover placement="bottom" width="65" trigger="hover">
              <el-image
                :src="
                  'https://o.bysjy.com.cn/public/images/other/s-' +
                  item.token +
                  '.png'
                "
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <el-button slot="reference">{{ item.city_name }}</el-button>
            </el-popover>
          </el-col>
        </el-row>
      </div>
    </section>

    <section class="bottom">
      <div class="container">
        <div class="company-info">
          <el-row :gutter="20">
            <el-col :span="5">
              <p class="info-t">用户帮助</p>
              <p class="info-txt">
                <el-link
                  href="https://m.bysjy.com.cn/student/kzp/user_agree.html?token=yunyan1536161856"
                  target="_blank"
                >
                  用户服务协议
                </el-link>
              </p>
              <p class="info-txt">
                <el-link
                  href="https://m.bysjy.com.cn/student/kzp/privacy.html?token=yunyan1536161856"
                  target="_blank"
                >
                  隐私政策
                </el-link>
              </p>
            </el-col>
            <el-col :span="7">
              <p class="info-t">联系方式</p>
              <!-- <p class="info-txt">
                客服热线：4006-922-999（周一至周五 8：30-18：00）
              </p> -->
              <p class="info-txt">服务邮箱：kzpservice@bibibi.net</p>
              <p
                class="info-service"
                @mouseover="show400Server = true"
                @mouseleave="show400Server = false"
              >
                <i class="el-icon-service"></i> 微信人工客服
              </p>
            </el-col>
            <el-col :span="12">
              <div class="b-img-wrap">
                <el-image :src="miniUrl">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <el-image :src="codeUrl">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-col>
            <p class="company-server" v-show="show400Server">
              <img src="https://o.bysjy.com.cn/kzp/yxz/400server.png" alt="" />
            </p>
          </el-row>
        </div>
        <div class="copyright">
          云研科技版权所有 | 技术支持：云研科技 |
          域名备案信息：<a target="_blank" href="https://beian.miit.gov.cn/">湘ICP备15008277号-4</a>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import Vue from "vue";
import { Link } from "element-ui";
Vue.use(Link);

export default {
  name: "SliderFooter",
  data() {
    return {
      show400Server: false,
      city_list: [],
      hot_cities: [
        {
          name: "北京",
          py: "Beijing",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-beijing_kzp_01.png",
        },
        {
          name: "上海",
          py: "Shanghai",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-shanghai_kzp_01.png",
        },
        {
          name: "广州",
          py: "Guangzhou",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-gh_94e980a03806.png",
        },
        {
          name: "深圳",
          py: "Shenzhen",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-shenzhen_kzp_01.png",
        },
        {
          name: "杭州",
          py: "Hangzhou",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-hangzhou_kzp_01.png",
        },
        {
          name: "昆明",
          py: "Kunming",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-kunming_kzp_01.png",
        },
        {
          name: "西安",
          py: "Xian",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-xian_kzp_01.png",
        },
        {
          name: "大连",
          py: "Dalian",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-dalian_kzp_01.png",
        },
        {
          name: "武汉",
          py: "Wuhan",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-wuhan_kzp_01.png",
        },
        {
          name: "重庆",
          py: "Chongqing",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-chongqing_kzp_01.png",
        },
        {
          name: "长沙",
          py: "changsha",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-changsha_kzp_01.png",
        },
        {
          name: "成都",
          py: "Chengdu",
          city_qrcode:
            "https://o.bysjy.com.cn/public/images/other/s-chengdu_kzp_01.png",
        },
        { name: "更多", py: "More" },
      ],
      curr_hot: 0,
      hot_timer: null,
      showMore: false,
      miniUrl: "https://o.bysjy.com.cn/kzp/yxz-mini-logo.jpg",
      codeUrl: "https://o.bysjy.com.cn/kzp/public/yun_jiu_ye.jpg",
    };
  },
  created() {
    this.getCities();
  },
  methods: {
    getCities() {
      let _self = this;

      let key = "cache_kzp_wx_account",
        data = [];

      // 判断是否有缓存
      try {
        data = JSON.parse(sessionStorage.getItem(key));
      } catch (error) {}

      if (_self.$util.isArrayFn(data) && data.length > 0) {
        _self.city_list = data || [];
        return;
      }

      this.$util.get("kzp_common", "kzp_wx_account", {}).then((res) => {
        const { code, data } = res;
        if (code === 1) {
          _self.city_list = data || [];
          sessionStorage.setItem(key, JSON.stringify(_self.city_list));
        } else {
          _self.$message.error(res.msg);
        }
      });
    },
    setCurrHot(i) {
      var that = this;
      clearTimeout(that.hot_timer);
      that.hot_timer = setTimeout(() => {
        if (i < that.hot_cities.length - 1) {
          that.curr_hot = i;
        } else {
          that.showMore = !that.showMore;
        }
      }, 150);
    },
    capitalize: ([first, ...rest], lowerRest = false) =>
      first.toUpperCase() +
      (lowerRest ? rest.join("").toLowerCase() : rest.join("")),
  },
};
</script>

<style scoped lang="scss">
.slider-footer {
  font-family: "sans-serif", "Microsoft YaHei";
  color: #31446a;

  .img-wrap,
  .slider-wrap {
    height: 150px;
  }

  img {
    height: 100%;
    max-height: 100%;
  }

  .slider-hot-box {
    display: flex;
    align-content: center;
    height: 100%;

    .hot-item {
      background: #f4f4f6;
      width: 57px;
      margin-left: 1px;
      transition: width 0.3s linear;
      cursor: pointer;

      .city-wrap {
        width: 57px;
        text-align: center;
        position: relative;
        cursor: pointer;

        .hot-city {
          width: 16px;
          font-size: 16px;
          margin: 0 auto;
          padding: 45px 0px 58px;
        }

        .hot-city-py {
          position: absolute;
          left: -6px;
          bottom: 10px;
          text-align: center;
          font-size: 10px;
          transform: scale(0.78);
          width: 124%;
        }
      }

      &.active {
        width: 187px;
        display: flex;

        .city-qr-code {
          display: block;
          width: 130px;
          overflow: hidden;
        }
      }

      .city-qr-code {
        width: 0px;
        padding: 35px 25px;
        display: none;
        box-sizing: border-box;
        transition: width 0.4s ease-in-out 0.2s;

        .code-img {
          width: 80px;
          height: 80px;
        }
      }
    }
  }

  .more-section {
    border-top: 1px solid #ddd;
    margin-top: 20px;
    padding: 10px 0px;

    .city-item {
      margin: 10px 0px;
    }
  }

  .bottom {
    background: #fafafa;
    margin-top: 80px;

    .company-info {
      position: relative;
      padding: 40px 0;

      .info-t {
        color: #282828;
        font-size: 18px;
        font-weight: bold;
      }

      .info-txt {
        color: #999999;
        font-size: 14px;
        margin-top: 12px;
      }

      .info-service {
        font-size: 14px;
        width: 103px;
        margin-top: 20px;
        border: 1px solid #007fff;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        color: #007fff;
        border-radius: 8px;
        text-align: center;
        cursor: pointer;
        &:hover {
          background-color: #007fff;
          color: #fff;
        }
      }

      .b-img-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .el-image {
          height: 120px;
          width: 120px;
          margin-left: 60px;
        }
      }

      .company-server {
        position: absolute;
        top: 0;
        left: 100px;
        width: 150px;
        height: 150px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .copyright {
      text-align: center;
      border-top: 1px solid #dddddd;
      line-height: 50px;
      color: #999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/SliderFooter.vue